import { render, staticRenderFns } from "./TabLogs.vue?vue&type=template&id=3cbb931b&"
import script from "./TabLogs.vue?vue&type=script&lang=js&"
export * from "./TabLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports